import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    theme: {
        dark: false,
        themes:{
            light:{
                primary: '#A30206',
                secondary: '#285a85'
            }
        }
    }
});
